import React from 'react';
import type { RuntimeStatus } from '../types/ui';

interface StatusPillProps {
  status: RuntimeStatus | 'success' | 'warning' | 'destructive' | 'info' | 'online' | 'idle' | 'disconnected';
  label?: string;
}

export const StatusPill: React.FC<StatusPillProps> = ({ status, label }) => {
  const statusLabels: Record<string, string> = {
    booting: 'Preparing runtime...',
    ready: 'Ready',
    running: 'Running...',
    crashed: 'Crashed',
    online: 'Online',
    idle: 'Idle',
    disconnected: 'Disconnected'
  };

  return (
    <span className={`status-pill status-${status}`}>
      {label || statusLabels[status] || status}
    </span>
  );
};
